import { flexRowBetween, flexRowCenterCenter } from '../../../common/styles/flex';
import { SITE_VARIABLES } from '../../../common/styles/variables';
import { PlayerSizesTypes } from '../../../common/store/store.types';
import { CLOSE_BAR_HEIGHT_BIG, CLOSE_BAR_HEIGHT_SMALL } from '../../../common/utils/common.constants';

interface StylesObject {
    closeBarContainerStyle: { [key: string]: any };
    circleCloseIconStyle: { [key: string]: any };
    closeIconStyle: { [key: string]: any };
    closeClickableWrapperStyle: { [key: string]: any };
}

const closeBarContainer = {
  ...flexRowBetween,
  alignItems: 'center',
  width: '100%',
  backgroundColor: SITE_VARIABLES.COLORS.BLACK,
  pointerEvents: 'auto',
  smallHeight: {
    height: `${CLOSE_BAR_HEIGHT_SMALL}px`,
  },
  bigHeight: {
    height: `${CLOSE_BAR_HEIGHT_BIG}px`,
  },
};

const closeIcon = {
  color: SITE_VARIABLES.COLORS.WHITE,
  cursor: 'pointer',
  margin: '0px 8px',
  medium: {
    height: '24px',
    width: '24px',
  },
  largeAndExtraLarge: {
    height: '16px',
    width: '16px',
  },
};

const closeClickableWrapper = {
  cursor: 'pointer',
  ...flexRowCenterCenter,
  margin: '0px 8px',
  medium: {
    height: '40px',
    width: '40px',
  },
  largeAndExtraLarge: {
    height: '24px',
    width: '24px',
  },
};

const circleCloseIcon = {
  color: SITE_VARIABLES.COLORS.WHITE,
  cursor: 'pointer',
  height: '37px',
  width: '37px',
  transform: 'translate(50%, -30%)',
  opacity: '0.95',
};

export const getCloseBarStyleObject = (playerSize: PlayerSizesTypes, stickyMode: boolean): StylesObject => {
  const extraSmallAndSmallSize = playerSize === 'extraSmall' || playerSize === 'small';
  const mediumSize = playerSize === 'medium';
  const largeAndExtraLargeSize = playerSize === 'large' || playerSize === 'extraLarge';
  const smallStickyMode = stickyMode && extraSmallAndSmallSize;
  return ({
    closeBarContainerStyle: [
      closeBarContainer,
      (extraSmallAndSmallSize || largeAndExtraLargeSize) && closeBarContainer.smallHeight,
      (smallStickyMode || mediumSize) && closeBarContainer.bigHeight,
    ],
    closeClickableWrapperStyle: [
      closeClickableWrapper,
      mediumSize && closeClickableWrapper.medium,
      largeAndExtraLargeSize && closeClickableWrapper.largeAndExtraLarge,
    ],
    closeIconStyle: [
      closeIcon,
      mediumSize && closeIcon.medium,
      largeAndExtraLargeSize && closeIcon.largeAndExtraLarge,
    ],
    circleCloseIconStyle: {
      ...circleCloseIcon,
    },
  });
};
